import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const data = [
  {
    quote: "To be the leading provider of high-quality electronic home appliances, electrical products, and stationery in Sri Lanka, renowned for our innovation, local manufacturing excellence, and unwavering commitment to customer satisfaction.",
    title: "Visson",
  },
  {
    quote: "To enhance the quality of life for Sri Lankan families by delivering cutting-edge, reliable, and affordable products. We strive to combine the best of global technology with local craftsmanship, ensuring our customers receive superior value and exceptional service. Through our dedication to integrity, reliability, and continuous improvement, we aim to build lasting relationships with our customers, partners, and stakeholders.",
    title: "Mission",
  },
];

const VissonMisson = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <section className="bg-white ">
        <div className='max-w-screen-xl px-4 pt-8 pb-4 mx-auto text-2xl font-bold text-center lg:py-16 lg:px-6 md:text-4xl'>
            Our Visson & Misson
        </div>
      <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
        <Slider {...settings}>
          {data.map((data, index) => (
            <figure key={index} className="max-w-screen-md mx-auto">
              <h1 className='py-4 text-3xl font-bold'>{data.title}</h1>
              
              <blockquote>
                <p className="text-2xl font-medium text-black ">" {data.quote} "</p>
              </blockquote>
            </figure>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default VissonMisson;
